import "./index.css";

import { Outlet } from "react-router-dom";
import { toast } from "react-toastify";
import {useContext, useEffect, useRef, useState} from "react";

import Sidebar from "../../Components/Sidebar";
import Navbar from "../../Components/Navbar";
import SidebarAssistant from "../../Components/SidebarAssistant";

export default function MainPage({ setIsAuth,sidebarMode }) {
  const offlineToastRef = useRef(null);





  function updateOnlineStatus(event) {
    navigator.onLine
      ? toast.dismiss(offlineToastRef.current) ||
        toast.success("اتصال به شبکه اینترنت برقرار است", {
          position: "top-center",
        })
      : (offlineToastRef.current = toast.error(
          "اتصال به شبکه اینترنت را بررسی نمایید",
          {
            position: "top-center",
            autoClose: false,
          }
        ));
  }


  window.addEventListener("online", updateOnlineStatus);
  window.addEventListener("offline", updateOnlineStatus);


    return (
    <>
      <div className="main-page">
        <Navbar setIsAuth={setIsAuth} />

       <Sidebar/> 
        {/*<Sidebar />*/}
        <Outlet  />
      </div>
    </>
  );
}
